module.exports = "<ngx-loading-bar color=\"#ff825a\" height=\"5px\" [includeSpinner]=\"true\"></ngx-loading-bar>\r\n<router-outlet></router-outlet>\r\n"